import { useCallback, useState } from 'react';

import type { WorkflowExecutionModel } from '~/server_shared/openapi/data-contracts';

export const useWorkflowExecutionsActions = () => {
  const [selectedExecution, setSelectedExecution] = useState<WorkflowExecutionModel | null>(null);
  const [detailsDialogOpen, setDetailsDialogOpen] = useState(false);

  const handleViewDetails = useCallback((execution: WorkflowExecutionModel) => {
    setSelectedExecution(execution);
    setDetailsDialogOpen(true);
  }, []);

  const handleCloseDetailsDialog = useCallback(() => {
    setDetailsDialogOpen(false);
    setSelectedExecution(null);
  }, []);

  return {
    handleViewDetails,
    selectedExecution,
    detailsDialogOpen,
    handleCloseDetailsDialog,
  };
};
